import { render } from "./AssignmentUsers.vue?vue&type=template&id=0bc000a2&scoped=true"
import script from "./AssignmentUsers.vue?vue&type=script&lang=js"
export * from "./AssignmentUsers.vue?vue&type=script&lang=js"

import "./AssignmentUsers.vue?vue&type=style&index=0&id=0bc000a2&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/views/assignment-users.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentUsers.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/assignment-users.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentUsers.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc000a2"]])

export default __exports__